import(/* webpackMode: "eager" */ "/var/www/716-cannabis/app/shop/search/page.tsx");
